import { render, staticRenderFns } from "./PencetakKurikulumK13.vue?vue&type=template&id=1ed16f59&scoped=true"
import script from "./PencetakKurikulumK13.vue?vue&type=script&lang=js"
export * from "./PencetakKurikulumK13.vue?vue&type=script&lang=js"
import style0 from "./PencetakKurikulumK13.vue?vue&type=style&index=0&id=1ed16f59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed16f59",
  null
  
)

export default component.exports